namespace RedBullMOBILE360.Sms {
    export class WhiteListColumns {
        static columnsKey = 'Sms.WhiteList';
    }
}